import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IssuerState {
    data: object;
}

const initialState: IssuerState = {
    data: {
        txHash: "",
        message: "",
        description: ""
    },
};

const status = createSlice({
    name: "status",
    initialState,
    reducers: {
        setData: (state, action: PayloadAction<object>) => {
            state.data = action.payload;
        },
    },
});

export const { setData } = status.actions;
export default status.reducer;
